module.exports = __webpack_public_path__ + "4def468cb02a7ae6ad8acbcc32131835.svg";